import { combineReducers } from "redux";
import { clientsReducer } from "./autolombard/clientsReducer";
import { currentRequestReducer } from "./autolombard/currentRequestReducer";
import { documentReducer } from "./autolombard/documentReducer";
import { requestsReducer } from "./autolombard/requestsReducer";

const autoLombardReducer = combineReducers({
  requests: requestsReducer,
  currentRequest: currentRequestReducer,
  document: documentReducer,
  clients: clientsReducer,
});

export default autoLombardReducer;
